module.exports = {"430624001":"文星街道","430624101":"东塘镇","430624104":"樟树镇","430624110":"三塘镇","430624116":"岭北镇","430624117":"新泉镇","430624118":"湘滨镇","430624119":"南湖洲镇","430624120":"鹤龙湖镇","430624122":"静河镇","430624124":"石塘镇","430624125":"洋沙湖镇","430624126":"金龙镇","430624201":"六塘乡","430624206":"杨林寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430624.json
// module id = 1990
// module chunks = 0